/* eslint-disable react/button-has-type */
import React from 'react';
import s from './FiltersFooter.scss';
import classNames from 'classnames';

import {FiltersSubmitButton} from '../FiltersSubmitButton/FiltersSubmitButton';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../galleryGlobalStrategy';
import {MobileFiltersPanelState} from '../../../../types/galleryTypes';
import {TextButton} from 'wix-ui-tpa';
import {Clear} from '@wix/wix-ui-icons-common/on-stage';

export interface IFiltersFooterProps extends IGalleryGlobalProps, IProvidedTranslationProps {
  shouldShowClearFiltersButton: boolean;
  closeMobileFiltersModal: Function;
  clearFilters: Function;
  filtersPanelState?: MobileFiltersPanelState;
}

class FiltersFooterComp extends React.Component<IFiltersFooterProps> {
  private clearFiltersButtonClicked() {
    const {
      experiments: {shouldApplyMobileFiltersEnhancements},
    } = this.props.globals;

    this.props.clearFilters(!shouldApplyMobileFiltersEnhancements);
  }

  private renderClearFiltersButton() {
    const {
      globals: {hasSelectedFilters, shouldShowMobile, isCategoryPage},
    } = this.props;

    return isCategoryPage ? (
      <TextButton
        data-hook="categories-clear-filters-button"
        onClick={() => this.clearFiltersButtonClicked()}
        className={classNames(s.clearFiltersButton, {
          [s.disabled]: !hasSelectedFilters,
          [s.categoryPage]: isCategoryPage,
        })}
        priority={'secondary' as any}
        suffixIcon={!shouldShowMobile && <Clear />}>
        {this.props.t('clearFiltersButtonText')}
      </TextButton>
    ) : (
      <button
        data-hook="clear-filters-button"
        onClick={() => this.clearFiltersButtonClicked()}
        className={classNames(s.clearFiltersButton, {
          [s.disabled]: !hasSelectedFilters,
          [s.clearButton]: isCategoryPage,
        })}>
        {this.props.t('clearFiltersButtonText')}
        {!shouldShowMobile && (
          <span className={s.clearFiltersX} data-hook="clear-filters-button-x">
            X
          </span>
        )}
      </button>
    );
  }

  public render() {
    const {shouldShowMobile, isCategoryPage} = this.props.globals;
    const {shouldShowClearFiltersButton, closeMobileFiltersModal, filtersPanelState} = this.props;
    const sortOnly = filtersPanelState === MobileFiltersPanelState.SORT_ONLY;
    const shouldShowFooterDivider = isCategoryPage && shouldShowMobile;

    return (
      <div className={classNames(s.actions, {[s.footerDivider]: shouldShowFooterDivider})}>
        {shouldShowClearFiltersButton && !sortOnly && this.renderClearFiltersButton()}
        {shouldShowMobile && (
          <FiltersSubmitButton closeMobileFiltersModal={closeMobileFiltersModal} fullWidth={sortOnly} />
        )}
      </div>
    );
  }
}

export const FiltersFooter = withGlobals(withTranslations()(FiltersFooterComp));
